import {CurrencyItem} from "./currencyItem";
/**
 * Created by alex.y on 7/20/2017.
 */
export class TableItem<T> {
   public Items : Array<T> = [];
    public Name:string;

    public constructor(obj: Partial<TableItem<T>>) {
        Object.assign(this, obj);
    }
}


// WEBPACK FOOTER //
// ./app/objects/currencyExchange/currencyTableItem.ts